const ArrowUpRight01Icon = /*#__PURE__*/ [
  ["path", { d: "M9 6.65032C9 6.65032 15.9383 6.10759 16.9154 7.08463C17.8924 8.06167 17.3496 15 17.3496 15M16.5 7.5L6.5 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowUpRight01Icon as default };
//# sourceMappingURL=ArrowUpRight01Icon.js.map
